import { TAG } from "../constants";
import { Task, TaskType } from "../types";
import { patientApi } from "./patientApi";

export const tasksApi = patientApi.injectEndpoints({
  endpoints: (builder) => ({
    //patient-tasks
    getPatientTasks: builder.query<Task[], void>({
      query: () => ({
        method: "GET",
        url: "/api/patient/tasks",
      }),
      providesTags: [TAG.TASKS],
    }),
    updatePatientTask: builder.mutation<Task, Partial<Task>>({
      query: ({ public_id, ...rest }) => ({
        method: "PUT",
        url: `/api/patient/tasks/${public_id}`,
        body: rest,
      }),
      // onQueryStarted: async (args, { dispatch, queryFulfilled }) => {
      //   const put = dispatch(
      //     patientApi.util.updateQueryData(
      //       "getPatientTasks",
      //       undefined,
      //       (draft) => {
      //         draft.forEach((t, index, ) => {
      //           if (t.id === args.id) {
      //             return {
      //               ...t,
      //               ...args,
      //             };
      //           }

      //           return t;
      //         });
      //       }
      //     )
      //   );

      //   queryFulfilled.catch(put.undo);
      // },
      invalidatesTags: [TAG.TASKS],
    }),
    getPatientTaskByType: builder.query<Task, TaskType>({
      query: (type) => ({
        method: "GET",
        url: `/api/patient/tasks/${type}`,
      }),
      providesTags: [TAG.TASKS],
    }),
  }),
});

export const {
  useGetPatientTasksQuery,
  useUpdatePatientTaskMutation,
  useGetPatientTaskByTypeQuery,
} = tasksApi;
